<head-meta [title]="this.title" />
<article>
    <div class="card w-full bg-base-100 shadow-xl">
        <div class="card-body">
            <ng-container *ngrxLet="sequenceEvent$ as sequenceEvent; error as e; complete as c">
                @if(sequenceEvent) {
                    <div class="navbar bg-base-100">
                        <div class="flex-none">
                          <a routerLink="/sequence-events" routerLinkActive="active" class="btn btn-square btn-ghost text-primary"><fa-icon [icon]="faArrowLeft" class="w-5"></fa-icon></a>
                        </div>
                        <div class="flex-1">
                          <h1 class="h1 ml-4">Sequence Event Detail</h1>
                        </div>
                        <div class="flex-none">
                            @if(this.auth.has('sequence_event_update')) {
                                <button [routerLink]="'/sequence-events/' + this.id + '/edit'" routerLinkActive="active" class="btn btn-ghost text-primary">
                                    <fa-icon [icon]="faPenToSquare" class="w-5"></fa-icon> Edit
                                </button>
                            }
                        </div>
                    </div>
                    <hr class="hr" />
                    <div class="overflow-hidden bg-white shadow sm:rounded-lg">
                        <div class="border-t border-gray-100">
                            <dl class="divide-y divide-gray-100">
                                <div>
                                    <app-detail-display title="Sequence Id" [value]="sequenceEvent.sequence_id.toString()" />
                                </div>
                                <!--
                                    event_id
                                -->
                                @if(this.auth.has('sequence_event_update')) {
                                    <div>
                                        <app-created-updated-display [entity]="sequenceEvent" />
                                    </div>
                                }
                            </dl>
                        </div>
                    </div>
                }
                <app-loading-error-block [error]="e?.error" [complete]="c" />
            </ng-container>
        </div>
    </div>
</article>